module.exports = __webpack_public_path__ + "static/media/logo-fi.b1745618.png";